import axios from 'axios';

axios.interceptors.response.use((response) => {
    return response;
}, function (error) {
    console.error(error);
    throw Error(error.statusText);
});

export default {
    axios
}